export default __webpack_public_path__ + "static/media/sectionThree1.95409811.png";